import { createRoute } from '@tanstack/react-router'
import { rootRoute } from '../__root'

import { GradientCard } from '@/components/ui/gradient-card'
import { GradientH1 } from '@/components/ui/gradient-text'
import { RoleSwitcher } from '@/components/ui/role-switcher'
import CaseList from '../../components/CaseList'
import { useAuth } from '@/contexts/AuthContext'

function ClientPage() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Role Switcher - only show if user has both lawyer AND client roles */}
      {user?.is_lawyer && user?.is_client && (
        <div className="fixed top-4 right-4 z-50">
          <RoleSwitcher size="sm" />
        </div>
      )}

      <div className="container mx-auto px-4 py-8 max-w-6xl">
        <div className="flex flex-col gap-8">
          {/* Header */}
          <div className="text-center">
            <GradientH1 className="mb-2">Your Claims</GradientH1>
            <p className="text-slate-500">Manage your flight compensation cases</p>
          </div>

          {/* Case Management Section */}
          <GradientCard>
            <CaseList />
          </GradientCard>
        </div>
      </div>
    </div>
  )
}

export const clientRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/client',
  component: ClientPage,
})
